module.exports = "::ng-deep app-pdf-viewer .page {\n    -webkit-box-shadow: 0px 0px 0px 1px #b0b0b0;\n            box-shadow: 0px 0px 0px 1px #b0b0b0;\n}"


//////////////////
// WEBPACK FOOTER
// ./public/app/common/pdf-viewer/pdf-viewer.component.css
// module id = ./public/app/common/pdf-viewer/pdf-viewer.component.css
// module chunks = main